var options = {
    rootMargin: "0px",
    threshold: 0.1,
};
var observer = new IntersectionObserver(handleIntersection, options);
var elements = document.querySelectorAll(".campbell-fade-in-text");
if (elements !== undefined && elements !== null) {
    [].forEach.call(elements, function (element) {
        observer.observe(element);
    });
}

function handleIntersection(entries) {
    entries.forEach(function (entry) {
        if (
            entry.intersectionRatio > 0 &&
            !entry.target.classList.contains("is-visible")
        ) {
            entry.target.classList.add("is-visible");
        }
    });
}
